import { render } from "./assegnazioni.vue?vue&type=template&id=38a99b9a&ts=true"
import script from "./assegnazioni.vue?vue&type=script&lang=ts"
export * from "./assegnazioni.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__